// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#result-designs-container[data-v-a461b120] {\n    padding: 50px 0 0 40px;\n}\n#workspace-result-designs[data-v-a461b120] {\n    background-color: #F2F2F2;\n    user-select: none;\n}\n.img-central[data-v-a461b120]{\n    object-position: center !important;\n}\n", ""]);
// Exports
module.exports = exports;
